/**
 * Serviço base para chamadas de API
 */

import { API_BASE_URL } from "@/lib/apiConfig";

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: {
    code: string;
    message: string;
  };
  message?: string;
}

/**
 * Faz uma requisição para a API
 */
export async function apiRequest<T>(
  endpoint: string,
  method: "GET" | "POST" | "PUT" | "DELETE" = "GET",
  body?: any
): Promise<T> {
  // Importar getToken do tokenService
  const { getToken } = await import("./tokenService");
  const token = getToken();

  const config: RequestInit = {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };

  if (body && method !== "GET") {
    config.body = JSON.stringify(body);
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, config);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
}

/**
 * Faz uma requisição GET
 */
export async function get<T>(endpoint: string): Promise<T> {
  return apiRequest<T>(endpoint, "GET");
}

/**
 * Faz uma requisição POST
 */
export async function post<T>(endpoint: string, body?: any): Promise<T> {
  return apiRequest<T>(endpoint, "POST", body);
}

/**
 * Faz uma requisição PUT
 */
export async function put<T>(endpoint: string, body?: any): Promise<T> {
  return apiRequest<T>(endpoint, "PUT", body);
}

/**
 * Faz uma requisição DELETE
 */
export async function del<T>(endpoint: string): Promise<T> {
  return apiRequest<T>(endpoint, "DELETE");
}
